import React from 'react'
import { Link } from 'react-router-dom'

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-6 sm:p-8">
          <div className="mb-8">
            <Link
              to="/signup"
              className="text-blue-600 hover:text-blue-700 text-sm font-medium"
            >
              ← 회원가입으로 돌아가기
            </Link>
          </div>
          
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">개인정보 수집 및 이용 동의</h1>
          
          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. 개인정보 수집 목적</h2>
            <p className="text-gray-700 mb-6">
              POD24는 다음의 목적을 위하여 개인정보를 수집·이용합니다:<br/>
              - 회원 가입 및 관리<br/>
              - 서비스 제공 및 계약이행<br/>
              - 고객 상담 및 불만 처리<br/>
              - 새로운 서비스 개발 및 맞춤형 서비스 제공<br/>
              - 서비스 이용 통계 및 분석
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. 수집하는 개인정보 항목</h2>
            <p className="text-gray-700 mb-6">
              <strong>필수정보:</strong><br/>
              - 이메일 주소<br/>
              - 성명(이름/업체명)<br/>
              - 비밀번호<br/>
              - 서비스 이용기록, 접속로그, 쿠키, 접속IP정보<br/><br/>
              
              <strong>선택정보:</strong><br/>
              - 마케팅 수신 동의 여부<br/>
              - 연락처 (고객 상담 시)
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. 개인정보 보유 및 이용기간</h2>
            <p className="text-gray-700 mb-6">
              1. 회사는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br/>
              2. 회원탈퇴 시: 탈퇴일로부터 즉시 파기 (단, 관계법령에 의한 보관의무가 있는 경우 예외)<br/>
              3. 관계법령에 의한 보관기간:<br/>
              - 계약 또는 청약철회에 관한 기록: 5년<br/>
              - 대금결제 및 재화등의 공급에 관한 기록: 5년<br/>
              - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년<br/>
              - 로그인 기록: 3개월
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. 개인정보의 제3자 제공</h2>
            <p className="text-gray-700 mb-6">
              회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다:<br/>
              - 이용자들이 사전에 동의한 경우<br/>
              - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. 개인정보 처리의 위탁</h2>
            <p className="text-gray-700 mb-6">
              회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다:<br/>
              - 클라우드 서비스 제공업체: 데이터 저장 및 관리<br/>
              - 이메일 발송 대행업체: 서비스 관련 이메일 발송<br/>
              - 고객센터 운영업체: 고객 상담 및 CS 업무
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. 개인정보의 기술적·관리적 보호조치</h2>
            <p className="text-gray-700 mb-6">
              회사는 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적·관리적 대책을 강구하고 있습니다:<br/>
              - 개인정보 암호화<br/>
              - 해킹 등에 대비한 기술적 대책<br/>
              - 개인정보 취급자의 최소화 및 교육<br/>
              - 개인정보보호 전담기구의 운영
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. 개인정보보호책임자</h2>
            <p className="text-gray-700 mb-6">
              성명: POD24 개인정보보호책임자<br/>
              이메일: privacy@pod24.com<br/>
              전화번호: 02-0000-0000
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. 권익침해 구제방법</h2>
            <p className="text-gray-700 mb-6">
              개인정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보보호위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다:<br/>
              - 개인정보보호위원회: privacy.go.kr (전화번호 국번없이 182)<br/>
              - 개인정보침해신고센터: privacy.kisa.or.kr (전화번호 국번없이 118)<br/>
              - 대검찰청 사이버범죄수사단: spo.go.kr (전화번호 02-3480-3573)<br/>
              - 경찰청 사이버테러대응센터: ctrc.go.kr (전화번호 국번없이 182)
            </p>

            <p className="text-sm text-gray-500 mt-8">
              시행일자: 2025년 1월 1일
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}